import { render } from "./InputMultil.vue?vue&type=template&id=cd0ae254"
import script from "./InputMultil.vue?vue&type=script&lang=js"
export * from "./InputMultil.vue?vue&type=script&lang=js"
script.render = render

export default script